import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import './styles.scss'
import {InputRow, MultiRangeSlider} from "../";

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const data = [
  {id: 1, item: 'fruit'},
  {id: 1, item: 'vegetable'},
  {id: 1, item: 'fishery'},
  {id: 1, item: 'cattle'},
  {id: 1, item: 'crime'},
  {id: 1, item: 'fresh'},
  {id: 1, item: 'juice'},
  {id: 1, item: 'none '},
  {id: 1, item: 'sale'},
]
export default function SimpleAccordion(props) {
  const classes = useStyles();
  const {title, itemsList, type, onchange,defaultExpanded=true} = props;
  return (
    <div className={classes.root}>
      <Accordion className='box-border' defaultExpanded={defaultExpanded}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className='box-border'
        >
          <Typography className='shop-category-text heading-color font-18  text-bold '>{title}</Typography>

        </AccordionSummary>
        <AccordionDetails className='display-flex flex-wrap ' style={{maxHeight: 180}}>
          {type === 'location' && <div className=' category-filters-container pt-10 pb-10'>

            <InputRow
              types={[
                {
                  type: '',
                  // value: values.priceUnit,
                  // error: errors.priceUnit,
                  label: 'location',
                },
              ]}
               onChangeInput={(value, key) => onchange(value)}
              numOfInputPerRow={1}
            />
          </div>}

          {type === 'productName' && <div className=' category-filters-container pt-10 pb-10'>
            <InputRow
              types={[
                {
                  type: '',
                  // value: values.priceUnit,
                  // error: errors.priceUnit,
                  label: 'product Name',
                },
              ]}

              onChangeInput={(value, key) => onchange(value)}
              numOfInputPerRow={1}
            />
          </div>
          }
          {type === 'checkbox' && <div className=' category-filters-container pt-10 pb-10'>
            {itemsList.map((i) => (
                <div key={i} className='checkbox-item'>
                  <input type='radio' value= {i.item} checked={i.item===props.value} onChange={(value, key) =>  onchange(value.target.value)}/>
                  <span>{i.item}</span>
                </div>
              )
            )}
          </div>}
          {type == 'website' && (
            data.map((item, index) => (
              <Accordion className='full-width border-none according-item'>
                <AccordionSummary
                  // expandIcon={<ExpandMoreIcon/>}
                  // expandIcon={<EditIcon/>}
                  // expandIcon={()=><span>+</span>}
                  // aria-controls="panel2a-content"
                  // id="panel2a-header"

                  style={{minHeight: 10,}}
                  className='inner-accordion'
                >
                  <span className='font-18 heading-color text-bold'>+</span> <Typography
                  className='shop-category-text heading-color font-14  ml-10 text-bold m-0'>{item.item}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{height: 90}}
                                  className='category-filters-container overflow-auto  ml-20  flex-wrap pb-10 pt-0'>
                  {itemsList.map((i) => (
                      <div key={i} className='full-width heading-color ml-20 pb-10 '>
                        <span>{i.item}</span>
                      </div>
                    )
                  )}
                </AccordionDetails>
              </Accordion>
            ))
          )}
          {type === 'price' &&
          // <div className=' category-filters-container pt-10 pb-10'>
          <div>
            <MultiRangeSlider
              min={1}
              max={100000}
              onChange={({min, max}) => {
                console.log(`min = ${min}, max = ${max}`)
               // onchange("between "+min+" and " +max)
               onchange(min,max)
              }}
            />
          </div>
          }
        </AccordionDetails>
      </Accordion>

      {/*<Accordion>*/}
      {/*  <AccordionSummary*/}
      {/*    expandIcon={<ExpandMoreIcon/>}*/}
      {/*    aria-controls="panel2a-content"*/}
      {/*    id="panel2a-header"*/}
      {/*  >*/}
      {/*    <Typography className={classes.heading}>Accordion 2</Typography>*/}
      {/*  </AccordionSummary>*/}
      {/*  <AccordionDetails>*/}
      {/*    <Typography>*/}
      {/*      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,*/}
      {/*      sit amet blandit leo lobortis eget.*/}
      {/*    </Typography>*/}
      {/*  </AccordionDetails>*/}
      {/*</Accordion>*/}
      {/*<Accordion disabled>*/}
      {/*  <AccordionSummary*/}
      {/*    expandIcon={<ExpandMoreIcon/>}*/}
      {/*    aria-controls="panel3a-content"*/}
      {/*    id="panel3a-header"*/}
      {/*  >*/}
      {/*    <Typography className={classes.heading}>Disabled Accordion</Typography>*/}
      {/*  </AccordionSummary>*/}
      {/*</Accordion>*/}
    </div>
  );
}
